import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P0003601FunctionFinish } from './P0003601/Installation/P0003601InstallationFinish';
import { P0003601FunctionReset } from './P0003601/Installation/P0003601InstallationReset';
import { P00039 } from './P00039';
import { P00032 } from './P00032';
import { P00030 } from './P00030';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P0003601FiltrationMiseEnOeuvreInit } from './P0003601/Filtration/miseenoeuvre/P0003601FiltrationMiseEnOeuvreInit';
import { P0003601FiltrationStatutComponent } from './P0003601/Filtration/cps/p0003601-filtration-statut/p0003601-filtration-statut.component';
import { P0003601FiltrationParametersComponent } from './P0003601/Filtration/cps/p0003601-filtration-parameters/p0003601-filtration-parameters.component';
import { P0003601FiltrationControleComponent } from './P0003601/Filtration/cps/p0003601-filtration-controle/p0003601-filtration-controle.component';
import { P0003601FiltrationMiseEnOeuvrePreventionGelComponent } from './P0003601/Filtration/miseenoeuvre/p0003601-filtration-mise-en-oeuvre-prevention-gel/p0003601-filtration-mise-en-oeuvre-prevention-gel.component';
import { P0003601FiltrationMiseEnOeuvrePreventionBacterieComponent } from './P0003601/Filtration/miseenoeuvre/p0003601-filtration-mise-en-oeuvre-prevention-bacterie/p0003601-filtration-mise-en-oeuvre-prevention-bacterie.component';
import { P0003601FiltrationMiseEnOeuvreProgrammeComponent } from './P0003601/Filtration/miseenoeuvre/p0003601-filtration-mise-en-oeuvre-programme/p0003601-filtration-mise-en-oeuvre-programme.component';
import { P0003601InstallationPompeComponent } from './P0003601/Installation/p0003601-installation-pompe/p0003601-installation-pompe.component';
import { P0003601CardFiltrationControleComponent } from './P0003601/Filtration/cards/p0003601-card-filtration-controle/p0003601-card-filtration-controle.component';
import { P0003601CardFiltrationStatutComponent } from './P0003601/Filtration/cards/p0003601-card-filtration-statut/p0003601-card-filtration-statut.component';
import { P0003601Alarm } from './P0003601/Alarm/P0003601Alarm';

export class P0003601Data {
  fvsCModeFonctionnement: number = 0;

  fvsCVitesseManuelle: number = 0;

  fvsCProgrammeFiltrationAuto: number = 0;

  fvsCConfirmationOTA: number = 0;

  fvsCResetUsine: number = 0;

  fvsPHorlogeVitesseJoursPPHA: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  fvsPHorlogeVitesseJoursPPHB: string =
    '000000000000000000000000000000000000000000000000';

  fvsPHorlogeVitesseSemainePPH: string = '000000000000000000000000';

  fvsPTypeHorlogePPH: number = 0;

  fvsPSeuilTemperature2424: number = 0;

  fvsPHorlogeVitesseJoursPPEA: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  fvsPHorlogeVitesseJoursPPEB: string =
    '000000000000000000000000000000000000000000000000';

  fvsPHorlogeVitesseSemainePPE: string = '000000000000000000000000';

  fvsPTypeHorlogePPE: number = 0;

  fvsPActivationFonction2424: number = 0;

  fvsPSeuilTemperatureHorsGel: number = 0;

  fvsIConfigurationProduit: number = 0;

  fvsITableTraductionVitesses: string = '00000000';

  fvsICapteurTemperatureReferenceHorsGel: number = 0;

  fvsICapteurTemperatureReference2424: number = 0;

  fvsSVitesseFiltration: number = 0;

  fvsSControleContacts: number = 0o000;

  fvsSEtatBouton: number = 0;

  fvsSFonctionnementPompe: number = 0;

  fvsSAlarme: number = 0;

  fvsSCourantConsommePompe: number = 0;

  fvsSTensionSecteur: number = 0;

  fvsSPuissanceApparente: number = 0;

  fvsSPuissanceActive: number = 0;

  fvsSCompteurPuissanceApparenteTotale: number = 0;

  fvsSCompteurPuissanceActiveTotale: number = 0;

  fvsSCompteurAmpereHeure: number = 0;

  fvsSTempsSousTension: number = 0;

  fvsSCompteurBouton: number = 0;

  fvsSEtatVitesse: number = 0;

  fvsSEtatContacts: number = 0;

  fvsSTemperatureReferenceDisponibleHorsGel: number = 0;

  fvsSEtatFonctionHorsGel: number = 0;

  fvsSTemperatureReferenceDisponible2424: number = 0;

  fvsSCompteAReboursSeconde72h: number = 0;

  fvsSVitesseFiltration72h: number = 0;

  fvsSVitesseFiltrationPPH: number = 0;

  fvsSVitesseFiltrationPPE: number = 0;

  fvsSMesureTemperatureHorsGel: number = 0;

  fvsSVitesseFiltrationHorsGel: number = 0;

  fvsSMesureTemperature2424: number = 0;

  fvsSVitesseFiltration2424: number = 0;

  fvsSAsservissementFonctionPrioriteElectrolyseurStandard: number = 0;

  fvsSAsservissementFonctionAutoMaintienElectrolyseurStandard: number = 0;

  fvsSAsservissementFonctionAutoMaintienInjectionCl: number = 0;

  fvsSAsservissementFonctionPrioriteElectrolyseurCellule: number = 0;

  fvsSAsservissementFonctionAutoMaintienElectrolyseurCellule: number = 0;

  fvsSAsservissementFonctionAutoMaintienInjectionPh: number = 0;

  fvsSAsservissementFonctionAutoMaintienPAC: number = 0;

  fvsSAsservissementFonctionRedemEclairageStandard: number = 0;

  fvsSAsservissementFonctionRedemTunable: number = 0;

  fvsSAsservissementFonctionPrioriteRobot: number = 0;

  fvsSAsservissementFonctionAutoMaintienRobot: number = 0;

  fvsSEntreeAsserviFonctionPrioritePacWp: number = 0;

  fvsSEntreeAsserviFonctionAutoMaintienPacWp: number = 0;

  fvsSVitesseFiltrationEntreeAsservie: number = 0;

  fvsSCompteurResetUsine: number = 0;

  fvsSEntreeAsserviFonctionPrioritePac: number = 0;

  fvsSEntreeAsserviFonctionPrioritePacPoly: number = 0;

  fvsSEntreeAsserviFonctionAutoMaintienPacPoly: number = 0;

  fvsSEntreeAsserviArretFiltrationVolet24: number = 0;

  fvsSEntreeAsserviArretFiltrationVolet230: number = 0;

  fvsSEntreeAsserviPrioriteBoostElectrolyseur: number = 0;

  fvsSAsservissement: number = 0;
}

export class P0003601 extends IProduct {
  override deviceTableIndex: number = 3;

  override modelIdentifier?: string = 'P00036-01';

  override dataIdentifier?: string = 'P0003601';

  override manufacturerName?: string = 'ACWA';

  data: P0003601Data = new P0003601Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0003601/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0003601/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0003601/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0003601;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0003601?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0003601.tuto.installation.help.title',
      helpSlides: [
        'P0003601.tuto.installation.help.1',
        'P0003601.tuto.installation.help.2',
        'P0003601.tuto.installation.help.3',
        'P0003601.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003601/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003601/installation-1_dark.png',
          },
          text: 'P0003601.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003601/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0003601/installation-2_dark.png',
          },
          text: 'P0003601.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003601/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003601/installation-1_dark.png',
          },
          text: 'P0003601.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0003601/update-2.png',
            dark: '/assets/ecosystem/images/products/P0003601/update-2_dark.png',
          },
          text: 'P0003601.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P0003601InstallationPompeComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P0003601FunctionFinish,
        reset: P0003601FunctionReset,
      },

      controlCards: [
        { component: P0003601CardFiltrationControleComponent, weight: 13 },
      ],

      statusCards: [
        { component: P0003601CardFiltrationStatutComponent, weight: 13 },
      ],

      alarms: {
        component: P0003601Alarm,
        weight: 13,
      },

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.FILTRATION];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.FILTRATION_VS ||
      functionnality == EventProductFunctionnalityEnum.FILTRATION
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P0003601FiltrationMiseEnOeuvreProgrammeComponent,
              condition: () => {
                return true;
              },
            },
            {
              component:
                P0003601FiltrationMiseEnOeuvrePreventionBacterieComponent,
              condition: (pool: Pool) => {
                return new P00039().hasProduct(pool, new P00032()) > 0;
              },
            },
            {
              component: P0003601FiltrationMiseEnOeuvrePreventionGelComponent,
              condition: (pool: Pool) => {
                return (
                  new P00039().hasProduct(pool, new P00032()) > 0 ||
                  new P00039().hasProduct(pool, new P00030()) > 0
                );
              },
            },
          ],
          init: P0003601FiltrationMiseEnOeuvreInit,
        },

        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P0003601FiltrationControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P0003601FiltrationParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P0003601FiltrationStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P0003601.parameters.historique.suivi.puissance',
                mode: HistoryGraphModeEnum.DATA,
                property: 'fvsSCompteurPuissanceActiveTotale',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.WATT,
                yModeOptions: { min: 0, max: 500 },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
            ],
          },
        },
      };
    }

    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.FiltrationVS_Controle,
      propertyName: 'fvsCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 17;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).fvsIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
